<div class="export-dialog">
  <div>
    <p class="export-dialog_title">
      {{ 'EXPORT_DIALOG.TITLE' | translate }}
    </p>

    <ng-container *ngIf="data.optionsForm">
      <p class="export-dialog_description">
        {{ 'EXPORT_DIALOG.OPTIONS.DESCRIPTION' | translate }}
      </p>

      <div class="export-dialog__options">
        <div class="export-dialog__options__option" *ngIf="data.optionsForm.get('locations')">
          <mat-checkbox [formControl]="data.optionsForm.get('locations')">
            <p class="export-dialog__options__option-text">
              {{ 'EXPORT_DIALOG.OPTIONS.LOCATIONS' | translate }}
            </p>
          </mat-checkbox>
        </div>
        <div class="export-dialog__options__option" *ngIf="data.optionsForm.get('companies')">
          <mat-checkbox [formControl]="data.optionsForm.get('companies')">
            <p class="export-dialog__options__option-text">
              {{ 'EXPORT_DIALOG.OPTIONS.LOCATION_COMPANIES' | translate }}
            </p>
          </mat-checkbox>
        </div>
        <ng-container>
          <div class="export-dialog__options__option" *ngIf="data.optionsForm.get('locationSectors')">
            <mat-checkbox [formControl]="data.optionsForm.get('locationSectors')">
              <p class="export-dialog__options__option-text">
                {{ 'EXPORT_DIALOG.OPTIONS.LOCATION_SECTORS' | translate }}
              </p>
            </mat-checkbox>
          </div>
          <div class="export-dialog__options__option" *ngIf="data.optionsForm.get('locationEnvironments')">
            <mat-checkbox [formControl]="data.optionsForm.get('locationEnvironments')">
              <p class="export-dialog__options__option-text">
                {{ 'EXPORT_DIALOG.OPTIONS.LOCATION_ENVIRONMENTS' | translate }}
              </p>
            </mat-checkbox>
          </div>
        </ng-container>
      </div>

      <p class="export-dialog_error" *ngIf="data.optionsForm.hasError('atLeastOneTrue')">
        {{ 'EXPORT_DIALOG.ERRORS.AT_LEAST_ONE_OPTION' | translate }}
      </p>
    </ng-container>

    <p
      *ngIf="!hasExceededLimit"
      class="export-dialog_description"
      [innerHTML]="'EXPORT_DIALOG.DESCRIPTION' | translate: { email: email }"
    ></p>
    <p
      *ngIf="hasExceededLimit"
      class="export-dialog_description"
      [innerHTML]="'EXPORT_DIALOG.DESCRIPTION_EXCEEDED_LIMIT' | translate: { exceedLimitCount: exceedLimitCount }"
    ></p>
  </div>

  <div class="export-dialog__buttons">
    <button
      mat-raised-button
      class="export-dialog__buttons-button export-dialog__buttons-button--white"
      [disabled]="isExporting"
      (click)="matDialogRef.close()"
    >
      {{ 'EXPORT_DIALOG.BUTTONS.CANCEL' | translate }}
    </button>

    <button
      *ngIf="!hasExceededLimit"
      mat-raised-button
      class="export-dialog__buttons-button"
      [disabled]="isExporting || (data.optionsForm && data.optionsForm.invalid)"
      (click)="export()"
    >
      {{ 'EXPORT_DIALOG.BUTTONS.EXPORT' | translate }}
    </button>
  </div>
</div>
